import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { UIContext } from '../../contexts/UIContext';
import SessionExpiredModal from './SessionExpiredModal';

const SessionExpirationListener = () => {
    const [isSessionExpired, setIsSessionExpired] = useState(false);
    const { logout } = useContext(AuthContext);
    const { setIsPageBlurred } = useContext(UIContext);

    useEffect(() => {
        const channel = new BroadcastChannel('vetra_session_channel');

        const handleLocalExpiration = () => {
            setIsSessionExpired(true);
            setIsPageBlurred(true); // Blurs the main app gracefully
            channel.postMessage('SESSION_EXPIRED'); 
        };

        const handleCrossTabMessage = (event) => {
            if (event.data === 'SESSION_EXPIRED') {
                setIsSessionExpired(true);
                setIsPageBlurred(true);
            }
        };

        // Listen for the manual UI event and cross-tab messages
        window.addEventListener('session-expired', handleLocalExpiration);
        channel.addEventListener('message', handleCrossTabMessage);

        return () => {
            window.removeEventListener('session-expired', handleLocalExpiration);
            channel.removeEventListener('message', handleCrossTabMessage);
            channel.close();
        };
    }, [setIsPageBlurred]);

    const handleSignBackIn = () => {
        setIsSessionExpired(false);
        setIsPageBlurred(false);
        logout(); // Safely clears context/cookies and redirects
    };

    return (
        <SessionExpiredModal 
            isOpen={isSessionExpired} 
            onSignBackIn={handleSignBackIn} 
        />
    );
};

export default SessionExpirationListener;